export const ANONYMOUS_ID = 'ajs_anonymous_id'
export const ANONYMOUS_ID_COOKIE_AGE = 60 * 60 * 24 * 365
